import { Injectable } from "@angular/core";
import { GeneralStore } from "../store/general";
import { GeneralDetailsStore } from "../store/general-details";
import { RequestDetailsStore } from "../store/request-details";
import { AttachmentsStore } from "../store/attachments";
import { DeclarationsStore } from "../store/declarations";
import { MCResponse, MCRootStoreService, MCUtils } from "@maslul/common-services";
import { ApplicantDetailsStore } from "../store/applicant-details";
import { MIHttpService } from "../shared/union-request-http";
import { Observable } from "rxjs";
import { ProductsStoreService } from "../store/products";
import { FormisFormStoreData } from "../../models/store/formis-form-store-data";
import { RequestApprovalTypeDetailsStore } from "../store/approval-type-details-store";

@Injectable({ providedIn: 'root' })
export class SendService {

    constructor(
        private generalStore: GeneralStore,
        private generalDetailsStore: GeneralDetailsStore,
        private requestDetailsStore: RequestDetailsStore,
        private attachmentsStore: AttachmentsStore,
        private declarationsStore: DeclarationsStore,
        private rootStoreService: MCRootStoreService,
        private applicantDetailsStore: ApplicantDetailsStore,
        private httpService: MIHttpService,
        private productsStore: ProductsStoreService,
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore
    ) {

    }


    getApprovalTypes() {
        const approvalTypeId = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;
        const approvalTypeName = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeName;
        const authorityId = this.requestApprovalTypeDetailsStore.getSnapshot().authorityId;

        return [
            {
                approvalTypeId: approvalTypeId,
                approvalTypeName: approvalTypeName,
                authorityId: authorityId
            }
        ]
    }
    getApplicantDetails() {
        const applicantDetails = this.applicantDetailsStore.getSnapshot().applicant;
        return applicantDetails;
    }
    getProducts() {
        const products: Map<string, FormisFormStoreData> = this.productsStore.getSnapshot().products as Map<string, FormisFormStoreData>;

        const productsToSend = [];

        for (const [id, product] of products.entries()) {
            const p = {
                id: id,
                formState: this.getFormState(),
                fieldsData: {
                    model: JSON.stringify(this.updateModel(product.formisFormModel)),
                    sectionsSchema: product.schemas
                }
            }
            productsToSend.push(p);
        }
        return productsToSend;
    }

    updateModel(model: any): any {
        if (MCUtils.isObject(model.productDetails.ModelCode)) { return model; }
        model.productDetails.ModelCode = { value: model.productDetails.ModelCode, label: model.productDetails.ModelCode }
        return model;
    }
    getGeneralDetails() {
        const formisFormModel = this.generalDetailsStore.getSnapshot().formisFormModel;
        const stringModel = JSON.stringify(formisFormModel);

        const fieldsSchema = this.generalDetailsStore.getSnapshot().fieldsSchema;
        const generalDetails = {
            model: stringModel,
            sectionsSchema: fieldsSchema
        }
        return generalDetails;

    }
    getRequestDetails() {
        const formisFormModel = this.requestDetailsStore.getSnapshot().formisFormModel;
        const stringModel = JSON.stringify(formisFormModel);

        const fieldsSchema = this.requestDetailsStore.getSnapshot().fieldsSchema;
        const requestDetails = {
            model: stringModel,
            sectionsSchema: fieldsSchema
        }
        return requestDetails;
    }
    getAttachmentsDetails() {
        const formisFormModel = this.attachmentsStore.getSnapshot().formisFormModel;
        const stringModel = JSON.stringify(formisFormModel);

        const fieldsSchema = this.attachmentsStore.getSnapshot().fieldsSchema;
        const attachments = {
            model: stringModel,
            sectionsSchema: fieldsSchema
        }
        return attachments;
    }
    getDeclartionDetails() {
        const formisFormModel = this.declarationsStore.getSnapshot().formisFormModel;
        const stringModel = JSON.stringify(formisFormModel);

        const fieldsSchema = this.declarationsStore.getSnapshot().fieldsSchema;
        const declarations = {
            model: stringModel,
            sectionsSchema: fieldsSchema
        }
        return declarations;
    }
    getFormState() {
        const formState = this.generalStore.getSnapshot().formState;
        const stringFormState = JSON.stringify(formState);
        return stringFormState;
    }
    getLanguage() {
        const language = this.rootStoreService.getSnapshot().language;
        return language;
    }

    getSendObj() {
        const requestObj = {
            language: this.getLanguage(),
            formState: this.getFormState(),
            attachmentsDetails: this.getAttachmentsDetails(),
            requestDetails: this.getRequestDetails(),
            generalDetails: this.getGeneralDetails(),
            declartionDetails: this.getDeclartionDetails(),
            applicantDetails: this.getApplicantDetails(),
            approvalTypes: this.getApprovalTypes(),
            products: this.getProducts()
        }
        return requestObj;
    }

    send(): Observable<MCResponse> {
        const requestData = this.getSendObj();
        return this.httpService.send(requestData)
    }
}